/**
 * The identity that scopes this app's persisted state.
 *
 * Every keyspace `@authe/fe-commons/storage` hands out — saved views, cached tx
 * bodies, brand overrides, dashboard prefs — is scoped by this tuple, so a tenant
 * or user switch reads a different keyspace instead of leaking one identity's
 * state into another. Hand-building it per call site invites one site to omit a
 * field and quietly share a keyspace across tenants; there were three copies of
 * the literal before this existed.
 */
import { useSession } from "@authe/ui-core/session";
import type { StorageIdentity } from "@authe/fe-commons/storage";
import { APPLICATION_SLUG } from "@/config";

/** This app's storage identity for the live session (all-null when signed out). */
export function useStorageIdentity(): StorageIdentity {
  const { session } = useSession();
  return {
    app: APPLICATION_SLUG,
    orgId: session?.tenant.orgId ?? null,
    tenantId: session?.tenant.tenantId ?? null,
    userId: session?.user.id ?? null,
  };
}
